import { useQuery } from 'src/shared/hooks/useQuery';
import { useStore } from 'zustand';

import type { TCompany } from '../types';

import { organizationStore } from '../store';

export const useActiveCompany = () => {
  const id = useStore(organizationStore, (state) => state.activeCompanyId);

  const setActiveCompany = useStore(
    organizationStore,
    (state) => state.setActiveCompanyId
  );

  const { data, isLoading } = useQuery<TCompany>({
    enabled: Boolean(id),
    queryKey: ['organization', 'companies', id],
    url: `organization/companies/${id}/`,
    urlParams: { paginate: false },
  });

  return {
    activeCompany: data,
    isLoadingActiveCompany: isLoading,
    setActiveCompany,
  };
};
